var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist';
import * as workflowsLib from '@debbie/cortex/dist/api/workflows';
import Button from '../Button';
import { ArrowLeft } from '../Icons';
import Edit from '../Icons/EditText';
import Input from '../Input';
import Modal from '../Modal';
const WorkflowInfo = (props) => {
    const workflow = props.workflow;
    const lang = useSelector((s) => s.lang);
    const [editInfoModalOpen, setEditInfoModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    useEffect(() => {
        setTitle(workflow.title);
        setDescription(workflow.description);
    }, [props.workflow]);
    const save = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            yield workflowsLib.update(workflow.workflowId, {
                title,
                description,
            });
            c.workflows.getAll();
            setEditInfoModalOpen(false);
        }
        catch (error) {
            console.error(error);
            alert('Error');
        }
        setLoading(false);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", { style: {
                cursor: 'pointer',
            } },
            React.createElement("span", { onClick: () => c.redirect.redirect('/settings/workflows') },
                React.createElement(ArrowLeft, null),
                " ",
                title || workflow.title),
            ' ',
            props.editable && (React.createElement(Edit, { onClick: (e) => setEditInfoModalOpen(!editInfoModalOpen) }))),
        editInfoModalOpen && (React.createElement(Modal, { onToggle: () => setEditInfoModalOpen(!editInfoModalOpen), header: "Info" },
            React.createElement(Input, { placeholder: lang.workflows.title, onKeyDown: (e) => {
                    if (e.key === 'Enter' && title && description) {
                        save();
                    }
                }, onChange: (e) => setTitle(e.target.value), value: title }),
            React.createElement(Input, { placeholder: lang.workflows.description, onKeyDown: (e) => {
                    if (e.key === 'Enter' && title && description) {
                        save();
                    }
                }, onChange: (e) => setDescription(e.target.value), value: description }),
            React.createElement(Button, { loading: loading, disabled: !(title && description), onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    save();
                }) }, lang.workflows.updateWorkflow),
            React.createElement(Button, { style: { float: 'right' }, theme: "secondary", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    const newWorkflow = yield workflowsLib.duplicateWorkflow(workflow.workflowId);
                    c.workflows.getAll();
                    c.redirect.redirect(`/workflows/${newWorkflow.workflowId}`);
                }) }, lang.workflows.duplicateWorkflow)))));
};
export default WorkflowInfo;
//# sourceMappingURL=WorkflowInfo.js.map